export const GOOGLE_PHOTOS_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 50;
export const UNSPLASH_PAGE_SIZE = 30;
